<template>
  <div v-loading="loading" class="facultyBox">
    <!-- <h1 class="header" @click="test">{{schoolInfo.schoolName}}>>学院管理</h1> -->
    <div class="filter boxlistTit">
      <el-input placeholder="学院" v-model="searchData.word" class="fl" style="width:300px;">
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <el-button class="fr" type="primary" @click="addMajor(null)">新建学院</el-button>
      <el-button class="fr" type="primary" @click="goRouter('/studentManage')" style="margin-right:10px">学生管理</el-button>
      <el-button class="fr" type="primary" @click="goRouter('/teacherManage')">教师管理</el-button>
      <!-- <el-button class="fr" @click="$router.go(-1)" style="margin-right:10px;">返回</el-button> -->
    </div>
    <div>
      <el-table
        :data="tableData"
        row-key="facultyNameId"
        @row-click="handelSelectRow"
        border
        :lazy="lazyType"
        :load="loadNode"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column label="学院名称" width="180">
          <template slot-scope="scope">{{scope.row.collegeName}}</template>
        </el-table-column>
        <el-table-column label="专业名称" width="180">
          <template slot-scope="scope">{{scope.row.majorName}}</template>
        </el-table-column>
        <el-table-column label="年级名称">
          <template slot-scope="scope">{{scope.row.gradeName}}</template>
        </el-table-column>
        <el-table-column label="班级名称">
          <template slot-scope="scope">{{scope.row.className}}</template>
        </el-table-column>
        <el-table-column prop="action" label="操作" width="350">
          <template slot-scope="scope">
            <div>
              <!-- 学院编辑 -->
              <el-button
                type="primary"
                size="small"
                @click="addMajor(scope)"
                v-if="scope.row.facultyNameType=='college'"
              >编辑学院</el-button>
              <el-button
                type="primary"
                size="small"
                @click="majorDetail(scope,'add')"
                v-if="scope.row.facultyNameType=='college'"
              >添加专业</el-button>
              <el-button
                type="primary"
                size="small"
                @click="majorDetail(scope)"
                v-if="scope.row.facultyNameType=='major'"
              >编辑专业</el-button>
              <el-button
                type="primary"
                size="small"
                v-if="scope.row.facultyNameType=='major'"
                @click="addgrade(scope,'add')"
              >添加年级</el-button>
              <!-- 年级编辑 -->
              <el-button
                type="primary"
                size="small"
                @click="addgrade(scope)"
                v-if="scope.row.facultyNameType=='grade'"
              >编辑年级</el-button>
              <el-button
                type="primary"
                size="small"
                v-if="scope.row.facultyNameType=='grade'"
                @click="addClass(scope,'add')"
              >添加班级</el-button>
              <el-button
                type="primary"
                size="small"
                v-if="scope.row.facultyNameType=='className'"
                @click="addClass(scope)"
              >编辑班级</el-button>
              <!-- <el-button type="success" size="small">上移</el-button>
              <el-button type="success" size="small">下移</el-button>-->
              <el-button type="error" size="small" @click="delCourse(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagin">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="searchData.showItem"
          :current-page.sync="searchData.pageIndex"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <el-dialog
        title="新建/编辑学院"
        :visible.sync="dialogVisible"
        width="450px"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        class="schoolVisible"
      >
        <p class="school">高校名称&nbsp;&nbsp;&nbsp;&nbsp;{{schoolInfo.schoolName}}</p>
        <p class="school">
          学院名称&nbsp;&nbsp;&nbsp;&nbsp;
          <el-input
            type="text"
            placeholder="请输入学院名称"
            v-model="collegeVal.name"
            maxlength="50"
            show-word-limit
            style="width: 300px;"
          ></el-input>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">保 存</el-button>
        </span>
      </el-dialog>
      <!-- 添加专业 -->
      <el-dialog
        title="新建/编辑专业"
        :visible.sync="majorVisible"
        width="450px"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        class="schoolVisible"
      >
        <p class="school">高校名称&nbsp;&nbsp;&nbsp;&nbsp;{{schoolInfo.schoolName}}</p>
        <p class="school">学院名称&nbsp;&nbsp;&nbsp;&nbsp;{{schoolInfo.collegeName}}</p>
        <p class="school">
          专业名称&nbsp;&nbsp;&nbsp;&nbsp;
          <el-input
            type="text"
            placeholder="请输入学院名称"
            v-model="majorVal.name"
            maxlength="50"
            show-word-limit
            style="width: 300px;"
          ></el-input>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="majorVisible = false">取 消</el-button>
          <el-button type="primary" @click="majorSave">保 存</el-button>
        </span>
      </el-dialog>
      <!-- 添加年级 -->
      <el-dialog
        title="新建/编辑年级"
        :visible.sync="gradeVisible"
        width="450px"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        class="schoolVisible"
      >
        <p class="school">高校名称&nbsp;&nbsp;&nbsp;&nbsp;{{schoolInfo.schoolName}}</p>
        <p class="school">学院名称&nbsp;&nbsp;&nbsp;&nbsp;{{gradeInfo.collegeTit}}</p>
        <p class="school">专业名称&nbsp;&nbsp;&nbsp;&nbsp;{{gradeInfo.majorTit}}</p>
        <p class="school">
          年级名称&nbsp;&nbsp;&nbsp;&nbsp;
          <el-input
            type="text"
            placeholder="请输入年级名称"
            v-model="gradeVal.name"
            maxlength="50"
            show-word-limit
            style="width: 300px;"
          ></el-input>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="gradeVisible = false">取 消</el-button>
          <el-button type="primary" @click="gradeSave">保 存</el-button>
        </span>
      </el-dialog>
      <!-- 添加班级 -->
      <el-dialog
        title="新建/编辑班级"
        :visible.sync="classVisible"
        width="450px"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        class="schoolVisible"
      >
        <p class="school">高校名称&nbsp;&nbsp;&nbsp;&nbsp;{{schoolInfo.schoolName}}</p>
        <p class="school">学院名称&nbsp;&nbsp;&nbsp;&nbsp;{{gradeInfo.collegeTit}}</p>
        <p class="school">专业名称&nbsp;&nbsp;&nbsp;&nbsp;{{gradeInfo.majorTit}}</p>
        <p class="school">年级名称&nbsp;&nbsp;&nbsp;&nbsp;{{gradeInfo.gradeTit}}</p>
        <p class="school">
          班级名称&nbsp;&nbsp;&nbsp;&nbsp;
          <el-input
            type="text"
            placeholder="请输入班级名称"
            v-model="classVal.name"
            maxlength="50"
            show-word-limit
            style="width: 300px;"
          ></el-input>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="classVisible = false">取 消</el-button>
          <el-button type="primary" @click="classSave">保 存</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
let schoolById = JSON.parse(localStorage.getItem("USER")).schoolId;
export default {
  data() {
    return {
      lazyType: true,
      collegeVal: {
        id: 0,
        name: "",
        schoolId: schoolById,
      }, // 新建学院
      majorVal: {
        collegeId: 0, // 学院
        id: 0, // 专业id; 新建时为0
        name: "",
        schoolId: schoolById,
      }, // 添加专业
      gradeVal: {
        id: 0,
        majorId: 0,
        name: "",
        schoolId: schoolById,
      }, // 添加年级
      classVal: {
        collegeId: 0,
        gradeId: 0,
        id: 0,
        majorId: 0,
        name: "",
        schoolId: schoolById,
      }, // 添加班级
      dialogVisible: false, // 新建学院模态框
      majorVisible: false, // 新建编辑专业模态框
      gradeVisible: false, // 添加年级
      classVisible: false, //添加班级
      schoolInfo: {},
      gradeInfo: {}, // 添加年级
      loading: false,
      total: 0,
      multipleSelection: [], // 获取选中数据
      tableData: [
        {
          facultyNameId: (new Date().getTime()+ "" + Math.round(Math.random() * 10000)),
          collegeName: "学院名称",
          majorName: "---", //专业名称
          gradeName: "---", //年级名称
          className: "---", //班级名称
          hasChildren: true,
          children: [],
          facultyNameType: "college",
        },
      ],
      searchData: {
        type: 0,
        pageIndex: 1,
        showItem: 10,
        word: "",
        schoolId: schoolById,
      },
      single: 1,
    };
  },
  methods: {
    goRouter(path){
      this.$router.push(path);
    },
    // 删除
    delCourse(item) {
      this.$confirm("您确认删除吗？?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          ids: [item.id],
          schoolId: schoolById,
        };
        if (item.facultyNameType == "college") {
          // 删除学院
          this.$api.allianceSchool.delCollege(param).then((res) => {
            if (res.errCode == 0) {
              this.searchData.pageIndex = 1;
              this.$message.success("删除成功");
              this.search();
            } else {
              this.$message.error(res.errMsg);
            }
          });
        } else if (item.facultyNameType == "major") {
          // 专业
          this.$api.allianceSchool.delMajor(param).then((res) => {
            if (res.errCode == 0) {
              this.searchData.pageIndex = 1;
              this.$message.success("删除成功");
              this.search();
            } else {
              this.$message.error(res.errMsg);
            }
          });
        } else if (item.facultyNameType == "grade") {
          // 年级
          this.$api.allianceSchool.delGrade(param).then((res) => {
            if (res.errCode == 0) {
              this.searchData.pageIndex = 1;
              this.$message.success("删除成功");
              this.search();
            } else {
              this.$message.error(res.errMsg);
            }
          });
        } else if (item.facultyNameType == "className") {
          // 班级
          this.$api.allianceSchool.delClass(param).then((res) => {
            if (res.errCode == 0) {
              this.searchData.pageIndex = 1;
              this.$message.success("删除成功");
              this.search();
            } else {
              this.$message.error(res.errMsg);
            }
          });
        }
      });
    },
    // 新增班级
    addClass(item, type) {
      this.gradeInfo = {};
      this.gradeInfo = item.row;
      this.classVal.collegeId = item.row.collegeId;
      this.classVal.gradeId = item.row.gradeTitId;
      this.classVal.majorId = item.row.majorId;
      if (type == "add") {
        this.classVal.name = "";
        this.classVal.id = 0;
      } else {
        this.classVal.name = item.row.name;
        this.classVal.id = item.row.id;
      }
      this.classVisible = true;
    },
    // 保存年级
    classSave() {
      this.classVal.name = this.classVal.name.trim();
      if (this.classVal.name == "") {
        this.$message.error("班级名称不能为空");
        return;
      }
      this.$api.allianceSchool.updateClass(this.classVal).then((res) => {
        if (res.errCode == 0) {
          this.classVisible = false;
          this.search();
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 新增年级
    addgrade(item, type) {
      this.gradeInfo = {};
      this.gradeInfo = item.row;
      this.gradeVal.majorId = item.row.majorId;
      if (type == "add") {
        this.gradeVal.name = "";
        this.gradeVal.id = 0;
      } else {
        this.gradeVal.name = item.row.name;
        this.gradeVal.id = item.row.id;
      }
      this.gradeVisible = true;
    },
    // 保存年级
    gradeSave() {
      this.gradeVal.name = this.gradeVal.name.trim();
      if (this.gradeVal.name == "") {
        this.$message.error("年级名称不能为空");
        return;
      }
      
      this.$api.allianceSchool.updateGrade(this.gradeVal).then((res) => {
        if (res.errCode == 0) {
          this.gradeVisible = false;
          this.search();
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 新增/编辑学院
    addMajor(item) {
      if (item) {
        this.collegeVal.name = item.row.collegeName;
        this.collegeVal.id = item.row.id;
      } else {
        this.collegeVal.name = "";
        this.collegeVal.id = 0;
      }
      this.dialogVisible = true;
    },
    // 保存学院
    save() {
      this.collegeVal.name = this.collegeVal.name.trim();
      if (this.collegeVal.name == "") {
        this.$message.error("学院名称不能为空");
        return;
      }
      
      this.$api.allianceSchool.updateCollege(this.collegeVal).then((res) => {
        if (res.errCode == 0) {
          this.dialogVisible = false;
          this.search();
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 添加、编辑专业
    majorDetail(item, type) {
      if (type == "add") {
        this.schoolInfo.collegeName = item.row.name;
        this.majorVal.collegeId = item.row.id;
        this.majorVal.name = "";
        this.majorVal.id = 0;
      } else {
        this.schoolInfo.collegeName = item.row.collegeTit;
        this.majorVal.collegeId = item.row.collegeId;
        this.majorVal.name = item.row.name;
        this.majorVal.id = item.row.id;
      }
      // this.schoolInfo.collegeName = item.row.name;
      // if (item.row.facultyNameType != "college") {
      //   this.majorVal.name = item.row.collegeName;
      //   this.majorVal.id = item.row.id;
      // } else {
      //   this.majorVal.name = "";
      //   this.majorVal.id = 0;
      //   this.majorVal.collegeId = item.row.id;
      // }
      this.majorVisible = true;
    },
    // 保存专业
    majorSave() {
      this.majorVal.name = this.majorVal.name.trim();
      if (this.majorVal.name == "") {
        this.$message.error("专业名称不能为空");
        return;
      }
      
      this.$api.allianceSchool.updateMajor(this.majorVal).then((res) => {
        if (res.errCode == 0) {
          this.majorVisible = false;
          this.search();
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },

    handelSelectRow(row, column, event) {
    },
    test() {
      // this.facultyNameId = this.tableData[0].facultyNameId;
    },
    async loadNode(tree, treeNode, resolve) {
      //  setTimeout(() => {
      // 添加专业
      if (tree.facultyNameType == "college") {
        const majorList = await this.major(tree);
        // console.loading(majorList)
        if (majorList.length > 0) {
          tree.children = majorList;
          resolve(majorList);
          this.tableData.filter(
            (item) => item.id == tree.id
          )[0].children = majorList;
        } else {
          resolve([]);
        }
      } else if (tree.facultyNameType == "major") {
        const majorList = await this.grade(tree);
        // 总数据下筛选某个专业
        const tableMajor = this.tableData.filter(
          (item) => item.id == tree.collegeId
        )[0].children;
        if (majorList.length > 0 && tableMajor.length > 0) {
          tree.children = majorList;
          resolve(majorList);
          tableMajor.filter(
            (item) => item.facultyNameId == tree.facultyNameId
          )[0].children = majorList;
          // this.tableData.filter(
          //   item => item.id == tree.id
          // )[0].children = majorList;
        } else {
          resolve([]);
        }
      } else if (tree.facultyNameType == "grade") {
        const majorList = await this.className(tree);
        //  总数据下筛选某个专业下的某个年级
        const tableGrade = this.tableData
          .filter((item) => item.id == tree.collegeId)[0]
          .children.filter((item) => item.id == tree.majorId)[0].children;
        if (majorList.length > 0 && tableGrade.length > 0) {
          tree.children = majorList;
          resolve(majorList);
          tableGrade.filter(
            (item) => item.facultyNameId == tree.facultyNameId
          )[0].children = majorList;
          // this.tableData.filter(
          //   item => item.id == tree.id
          // )[0].children = majorList;
        } else {
          resolve([]);
        }
      }
    },
    search() {
      this.loading = true;
      this.$api.allianceSchool
        .getCollegeList(this.searchData)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            const options = [];
            res.data.items.forEach((item, i) => {
              options[i] = {
                ...item,
                facultyNameId: (new Date().getTime()+ "" + Math.round(Math.random() * 1000)) + i,
                collegeName: item.name,
                majorName: "---",
                gradeName: "---",
                className: "---",
                hasChildren: true,
                children: [],
                facultyNameType: "college",
              };
            });
            this.tableData = options;
            this.total = res.data.totalItems;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    // 专业名称
    async major(collegeId) {
      const param = {
        collegeId: collegeId.id, // 学院id
        schoolId: schoolById,
      };
      const options = [];
      await this.$api.allianceSchool.getMajorList(param).then((res) => {
        if (res.errCode == 0) {
          res.data.forEach((item, i) => {
            options[i] = {
              ...item,
              facultyNameId: (new Date().getTime()+ "" + Math.round(Math.random() * 1000)) + i,
              collegeName: "---",
              collegeTit: collegeId.name,
              majorTit: item.name,
              majorId: item.id,
              majorName: item.name,
              collegeId: collegeId.id,
              gradeName: "---",
              className: "---",
              hasChildren: true,
              children: [],
              facultyNameType: "major",
            };
          });
        } else {
          this.$message.error(res.errMsg);
        }
      });
      return options;
    },
    // 年级名称
    async grade(item) {
      const param = {
        majorId: item.id,
        schoolId: schoolById,
      };
      const options = [];
      await this.$api.allianceSchool.getGradeList(param).then((res) => {
        if (res.errCode == 0) {
          res.data.forEach((resItem, i) => {
            options[i] = {
              ...resItem,
              facultyNameId:(new Date().getTime()+ "" + Math.round(Math.random() * 1000)) + i,
              collegeName: "---",
              majorName: "---",
              collegeId: item.collegeId, // 学院id
              majorId: item.id, // 专业id
              gradeName: resItem.name,
              className: "---",
              hasChildren: true,
              children: [],
              facultyNameType: "grade",
              collegeTit: item.collegeTit,
              majorTit: item.majorTit,
              gradeTit: resItem.name,
              gradeTitId: resItem.id,
            };
          });
        } else {
          this.$message.error(res.errMsg);
        }
      });
      return options;
    },
    // 班级名称
    async className(item) {
      const param = {
        gradeId: item.id,
        schoolId: schoolById,
      };
      const options = [];
      await this.$api.allianceSchool
        .collegeMgrGetClassList(param)
        .then((res) => {
          if (res.errCode == 0) {
            res.data.forEach((resItem, i) => {
              options[i] = {
                ...resItem,
                facultyNameId: (new Date().getTime()+ "" + Math.round(Math.random() * 1000)) + i,
                collegeName: "---",
                majorName: "---",
                collegeId: item.collegeId,
                majorId: item.majorId,
                gradeName: "---",
                className: resItem.name,
                hasChildren: false,
                children: [],
                facultyNameType: "className",
                collegeTit: item.collegeTit,
                majorTit: item.majorTit,
                gradeTit: item.gradeTit,
                gradeTitId: item.gradeTitId,
                classTit: resItem.name,
              };
            });
          } else {
            this.$message.error(res.errMsg);
          }
        });
      return options;
    },
    handleSelectionChange(select, row) {
      console.log(select, row);
      // this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.searchData.pageIndex = 1;
      this.searchData.showItem = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.searchData.pageIndex = val;
      this.search();
    },
    // 学院管理头部
    getSchoolInfo() {
      this.loading = true;
      this.$api.allianceSchool
        .getSchoolInfo(schoolById)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.schoolInfo = res.data;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
  },
  created() {
    this.search();
    this.getSchoolInfo();
  },
};
</script>

<style lang="less" scoped>
.facultyBox {
  flex: 1;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  .fr {
    float: right;
  }
  .pagin {
    text-align: center;
    margin-top: 20px;
  }
  .school {
    height: 40px;
  }
  .schoolVisible .el-dialog__body {
    padding: 10px 20px;
  }
  .ivu-message {
    z-index: 3000 !important;
  }
  .filter {
    margin-bottom: 30px;
    clear: both;
    overflow: hidden;
  }
}
</style>